import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments'

export const GET_STORE = gql`
  query GetStore($id: ID!) {
    store(id: $id) {
      ...Store
    }
  }
  ${STORE_FRAGMENT}
`
